import { ReactElement } from 'react';

import { InjectableViewsAdapterProps } from './types';

export type LayoutAdapter = ({ Component, routes, endpoint }: InjectableViewsAdapterProps) => ReactElement;

export interface LayoutHandler {
  setNext(handler: LayoutHandler): LayoutHandler;
  handle(route: string): LayoutAdapter;
}

export abstract class AbstractLayoutHandler implements LayoutHandler {
  private nextHandler: LayoutHandler;

  public setNext(handler: LayoutHandler): LayoutHandler {
    this.nextHandler = handler;
    return handler;
  }

  public handle(route: string): LayoutAdapter {
    if (this.nextHandler) {
      return this.nextHandler.handle(route);
    }

    throw new Error(`Cannot find handler for route ${route}`);
  }
}
